import React from 'react';
import { View } from 'react-native';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet, useAppointmentStatus } from '../../../hooks';
import { Text } from '../../Text';
export const Footer = ({ status, participantStatus }) => {
    const config = useAppointmentStatus(status, participantStatus);
    const styles = useStyleSheet(getStyles(config));
    return (React.createElement(View, { style: styles.container },
        config.color && React.createElement(View, { style: styles.circle }),
        React.createElement(Text, { style: styles.status, type: 'body', size: 'sm', weight: 'semibold' }, config.text)));
};
const getStyles = (config) => createStyleSheet(({ color, size }) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    circle: {
        width: size.F,
        height: size.F,
        borderRadius: size.F,
        backgroundColor: config.color,
        marginRight: size.C
    },
    status: {
        flex: 1,
        color: config.color ? color.invert2.p100 : color.primary.solid
    }
}));
//# sourceMappingURL=Footer.js.map